module.exports = ".example-icon {\n    padding: 0 14px;\n  }\n  .icon-spacer {\n    padding-right: 20px;\n  }\n  .example-spacer {\n    -webkit-box-flex: 1;\n        -ms-flex: 1 1 auto;\n            flex: 1 1 auto; \n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/toolbar/toolbar.component.css
// module id = ./src/app/toolbar/toolbar.component.css
// module chunks = main